import { render } from "./TicketValidatedView.vue?vue&type=template&id=0566c1e7&scoped=true"
import script from "./TicketValidatedView.vue?vue&type=script&lang=js"
export * from "./TicketValidatedView.vue?vue&type=script&lang=js"

import "./TicketValidatedView.vue?vue&type=style&index=0&id=0566c1e7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0566c1e7"]])

export default __exports__